<template>
  <v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel" persistent>
    <v-card>
      <v-toolbar dark color="info" dense flat>
        <v-toolbar-title class="text-body-2 font-weight-bold text-white">Please <span class="text-lowercase">{{ title }}</span></v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4" v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="!options.noconfirm" color="error" text class="body-2 font-weight-bold" @click.native="cancel" >Back</v-btn>
        <v-btn color="info" class="body-2 font-weight-bold" @click.native="agree">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        title: null,
        options: {
          color: "grey lighten-3",
        //   color: this.$vuetify.theme.themes['light'].primary,
          width: 400,
          zIndex: 200,
          noconfirm: false,
        },
      };
    },

    methods: {
      open(title, message, options) {
        this.dialog = true;
        this.title = title;
        this.message = message;
        this.options = Object.assign(this.options, options);
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },
      agree() {
        this.resolve(true);
        this.dialog = false;
      },
      cancel() {
        this.resolve(false);
        this.dialog = false;
      },
    },
  };

    // <confirm-dialog ref="confirm"></confirm-dialog>
    // async buttonfunction(){
    //     if(await this.$refs.confirm.open("Confirm", "Are you sure you want to delete all record?")){
    //         console.log("TEST");
    //     }
    // },
</script>



